var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scene",class:{
    'main-full': !_vm.navbarLocked
  },attrs:{"id":"main-cube-scene"}},[_c('div',{class:{
      'overflow-hidden': _vm.scrollLocked
    },attrs:{"id":"main"}},[_c('div',{attrs:{"id":"main-content"}},[_c('div',{staticClass:"row"},[_c('Breadcrumbs'),_c('div',{staticClass:"col s12"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"},on:{"beforeLeave":_vm.beforeLeave,"enter":_vm.enter,"afterEnter":_vm.afterEnter}},[_c('router-view',{key:_vm.reloadRouterKey})],1)],1)],1)]),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }